
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-custom.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-chat-provider-custom-demo-custom-provider-width-ui"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-custom.zh-CN.md?type=demo')
};